import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { auth } from '../../utils/Auth';
import OverlayLoader from '../common/OverlayLoader';

type AuthoriserState = {
  isAuthorising: boolean;
};

class Authoriser extends React.Component<{}, AuthoriserState> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      isAuthorising: true,
    };
  }

  componentDidMount() {
    auth
      .renewSession()
      .then(() => {
        this.setState({ isAuthorising: false });
      })
      .catch(() => {
        if (window.location.hash.startsWith('#error=unauthorized&error_description=VERIFY_EMAIL')) {
          window.location.assign(`${process.env.REACT_APP_PLATFORM_URI}/confirm`);
        } else {
          auth.login();
        }
      });
  }

  render() {
    const { isAuthorising } = this.state;
    const { children } = this.props;
    return isAuthorising ? <OverlayLoader /> : children;
  }
}

export default Authoriser;
